import { ImportModalView } from '../types';
export function getModalTitle(view, t) {
    switch (view) {
        case ImportModalView.SELECTION:
            return t('spreadsheet.import.modal.title.selection');
        case ImportModalView.INSTRUCTIONS:
            return t('spreadsheet.import.modal.title.instructions');
        default:
            return t('spreadsheet.import.modal.title.upload');
    }
}
